import "core-js/modules/es6.regexp.replace";
import "core-js/modules/es6.regexp.search";
// Review scenarios (#324), on dev and on the test server (#472). A link with ?scenario=<name>[:<stop>] logs in as the
// scenario's account, opens its screen and walks its steps up to the named stop point, so the user (or the boss, from
// the weekly report) looks at exactly the moment to check (a drawing just before it is closed, say). Any route works:
// /welcome?scenario=draw-polygon:before-close. The scenarios are in src/dev/scenarios.js; on dev they log in as the
// local test accounts, in the test build as the demo accounts. Production never loads them (process.env.SCENARIOS is
// false there, so the build drops the import). With review=<pr>[:<check>] as well, the phone's review button comes on
// top (dev only: dev-tools/review/widget.js, served by the dev server).
export default (function (_ref) {
  var router = _ref.router;

  if (process.env.SCENARIOS) {
    if (typeof window === 'undefined') return;
    var query = new URLSearchParams(window.location.search);

    if (process.env.DEV && query.get('review')) {
      // kept for the widget: the scenario's navigation takes it out of the address before the script runs
      window.__reviewAsked = query.get('review');
      var script = document.createElement('script');
      script.src = '/__dev/review/static/widget.js';
      document.body.appendChild(script);
    }

    var asked = query.get('scenario');
    if (!asked) return; // the address the link opened, read before the router's guards may send a logged-out visitor elsewhere
    // (open:<account> stays there; #331 found /inbox ending on /welcome)
    // (resolved by the router itself: its decoding and query parsing, the router's base taken off at a boundary)

    var base = (router.options.base || '/').replace(/\/$/, '');
    var path = window.location.pathname;
    var inBase = !base || path === base || path.indexOf(base + '/') === 0;

    var _router$resolve = router.resolve((inBase ? path.slice(base.length) || '/' : path) + window.location.search),
        route = _router$resolve.route;

    var link = {
      path: route.path,
      query: route.query
    };
    router.onReady(function () {
      import("../dev/scenarios").then(function (m) {
        return m.runScenario(asked, router, link);
      }).catch(function (err) {
        console.error('[scenario] ' + asked + ': ' + (err && err.message)); // a failed one is done too: the review page goes on with its next frame

        if (window.parent !== window) window.parent.postMessage({
          type: 'scenario-ready',
          scenario: asked,
          failed: true
        }, '*');
      });
    });
  }
});